import React from 'react'
import clsx from 'clsx'
import { FileViewerContent, SectionLayoutDialog } from 'shared'

import { useStyles } from './FileViewerDialog.style'

const FileViewerDialog = ({
  fileExtension = '',
  isLocalFile = false,
  fileUrl,
  mediumSize = false,
  title,
  cropperClassName,
  className,
  transparent = false,
  zoomDisabled = false,
  ...dialogProps
}) => {
  const classes = useStyles()

  return (
    <SectionLayoutDialog
      {...dialogProps}
      title={title}
      className={clsx(classes.dialog, className)}
      contentClassName={classes.container}
      direction='down'
      headerContainerClassName={classes.header}
      fullScreen={!mediumSize}>
      <FileViewerContent
        fileExtension={fileExtension}
        fileUrl={fileUrl}
        transparent={transparent}
        zoomDisabled={zoomDisabled}
        cropperClassName={cropperClassName}
        isLocalFile={isLocalFile}
      />
    </SectionLayoutDialog>
  )
}

export default FileViewerDialog
